export default {
  productWithFormDefaultAgreement:
    "product/product-with-form/default-agreement",
} as const;
